import { createContext, useContext, useEffect, useState } from "react";
import { useGeneralSetting } from "./GeneralSettingContext";
import { downloadData } from 'aws-amplify/storage';
import { apiGetEmergencyRoutes } from '../apis/EmergencyRouteApi';

const Context = createContext({});

export default function GeoCoordinateProvider({ children }) {
  const { generalSetting } = useGeneralSetting();
  const [wardBoundary, setWardBoundary] = useState(null);
  const [emergencyRoutes, setEmergencyRoutes] = useState([]);

  const retrieveCoordinateBoundary = async () => {
    try {
      const { body } = await downloadData({ key: 'setting/ward_boundaries.json' }).result;
      const setting = JSON.parse(await body.text());
      if (!setting) setWardBoundary(null);

      /**
       * Remove the first element which is 'City Boundary'
       */
      const newBorderSettings = generalSetting?.borderSettings?.slice(1);

      const data = newBorderSettings?.map((location) => {
        const locationId = location?.id;
        const color = location?.color;
        if (locationId && color) {
          if (setting && setting[locationId]) {
            return { data: setting[locationId], color };
          }
        }
        return null;
      });
      setWardBoundary(data);

    } catch (err) {
      setWardBoundary(null);
    }
  }

  const loadEmergencyRoutes = async () => {
    try {
      const result = await apiGetEmergencyRoutes();

      if (result.success) {
        if (Array.isArray(result.data) && result.data.length > 0) {
          // Data is an array with full information, sort by displayOrder
          const sortedRoutes = result.data.sort((a, b) => a.displayOrder - b.displayOrder);
          setEmergencyRoutes(sortedRoutes);
        } else {
          // Empty array or no data
          setEmergencyRoutes([]);
        }
      } else {
        // File doesn't exist or error occurred
        setEmergencyRoutes([]);
      }
    } catch (error) {
      console.error('Error loading emergency routes:', error);
      setEmergencyRoutes([]);
    }
  };

  const refreshEmergencyRoutes = async () => {
    await loadEmergencyRoutes();
  };

  useEffect(() => {
    retrieveCoordinateBoundary();
  }, [generalSetting]);

  useEffect(() => {
    loadEmergencyRoutes();
  }, []);

  return (
    <Context.Provider value={{ wardBoundary, emergencyRoutes, setWardBoundary, setEmergencyRoutes, refreshEmergencyRoutes }}>
      {children}
    </Context.Provider>
  );
}

export const useGeoCoordinate = () => useContext(Context);